import {useContext} from 'react';

import {DrawerContext} from './DrawerMenuProvider';

export const useDrawer = () => useContext(DrawerContext);
